otuApp.getTemplateParams = function (options={}) {
	var _options = Object.assign({tmpl:'columns-all'},options);
    return ($('[data-template-position="' + _options.tmpl + '"]').data('templateParams') || {});
}